__turbopack_context__.v({
  "container": "Tst9Ya_container",
  "more": "Tst9Ya_more",
  "pricesMain": "Tst9Ya_pricesMain",
  "visibleCount--1": "Tst9Ya_visibleCount--1",
  "visibleCount--2": "Tst9Ya_visibleCount--2",
  "visibleCount--3": "Tst9Ya_visibleCount--3",
});
